import { useState } from "react";
import clsx from "clsx";
import GuideBody from "@/components/guides/GuideBody";

// `html` is set for questions an organizer wrote: their answers go through
// MarkdownRenderer server-side, and `a` is the source it was made from. Never
// render `a` as markup.
export type FaqItem = { q: string; a: string; html?: string };

// The Figma's faq.csv panel: two columns of rows that each carry a chevron and
// open on click, rather than showing every answer at once.
export default function FaqList({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 gap-x-8 md:grid-cols-2">
      {items.map((item) => {
        const isOpen = open === item.q;
        return (
          <div key={item.q} className="border-line/20 border-b">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : item.q)}
              className="focus-visible:ring-viking focus-visible:ring-offset-surface flex w-full cursor-pointer items-center gap-3 py-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
            >
              <span className="font-display text-body text-ink flex-1 font-bold">
                {item.q}
              </span>
              <span
                aria-hidden
                className={clsx(
                  "text-ink-muted duration-fast ease-standard shrink-0 leading-none transition-transform",
                  isOpen && "rotate-180",
                )}
              >
                ▾
              </span>
            </button>

            {isOpen &&
              (item.html ? (
                <div className="text-body text-ink-muted pb-4">
                  <GuideBody html={item.html} />
                </div>
              ) : (
                <p className="text-body text-ink-muted pb-4">{item.a}</p>
              ))}
          </div>
        );
      })}
    </div>
  );
}
